import React from 'react';
import '../styles/Terms.css'; // Arquivo de estilos

function Terms() {
  return (
    <div className="terms-container">
      <h1>Termos de Utilização</h1>
      <p>
        Ao acessar e utilizar este site, você concorda com os seguintes termos de utilização. Se você não concorda com algum destes termos, por favor, não utilize nosso site.
      </p>
      <h2>Uso do Site</h2>
      <p>
        O conteúdo deste site é apenas para fins informativos. Não garantimos a exatidão ou a atualidade das informações.
      </p>
      <h2>Propriedade Intelectual</h2>
      <p>
        Todo o conteúdo, incluindo textos, imagens e gráficos, são de propriedade da LF DEVELOPER e estão protegidos por direitos autorais.
      </p>
      <h2>Alterações nos Termos</h2>
      <p>
        Podemos atualizar nossos termos de uso a qualquer momento. Recomendamos que você revise esta página periodicamente.
      </p>

      <h1>Política de Privacidade</h1>
      <p>
        Sua privacidade é importante para nós. Esta política explica como coletamos, usamos e protegemos suas informações.
      </p>
      <h2>Coleta de Informações</h2>
      <p>
        Coletamos informações pessoais fornecidas por você ao preencher formulários ou entrar em contato conosco.
      </p>
      <h2>Uso das Informações</h2>
      <p>
        Utilizamos suas informações para responder a consultas e melhorar nossos serviços.
      </p>
      <h2>Segurança</h2>
      <p>
        Adotamos medidas de segurança para proteger seus dados, mas não podemos garantir segurança absoluta.
      </p>
      <h2>Contato</h2>
      <p>
        Se tiver dúvidas sobre nossos termos ou política de privacidade, entre em contato pelo e-mail: contato@lf.dev.br.
      </p>
    </div>
  );
}

export default Terms;
